module.exports = __webpack_public_path__ + "img/gb93-87________16.prt.40981bd9.jpg";